import { Typography } from "@material-ui/core";
import React from "react";
import { Constant } from "./../../Constant";

function ParameterTooltip({
    mulToolTip = false,
    title = null,
    multiLine = null,
    formId,
}) {
    const isTooltipList = Constant.ParameterTooltipList;
    const isAddTooltip = isTooltipList.includes(formId);

    return (
        isAddTooltip && (
            <>
                {title ? <Typography color="error">{title}</Typography> : null}
                {multiLine
                    ? mulToolTip
                        ? Object.entries(multiLine).map(([key, value]) => {
                              return (
                                  <Typography color="error" key={key}>
                                      {value}
                                  </Typography>
                              );
                          })
                        : null
                    : null}
            </>
        )
    );
}

export default ParameterTooltip;
